<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.DESC')"
    />
    <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.tenantId.$error }">
          {{ $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.TENANT_ID.LABEL') }}
          <input
            v-model.trim="tenantId"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.TENANT_ID.PLACEHOLDER')
            "
            @blur="$v.tenantId.$touch"
          />
          <span v-if="$v.tenantId.$error" class="message">{{
            $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.TENANT_ID.ERROR')
          }}</span>
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.TENANT_ID.SUBTITLE') }}
        </p>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.callbackUrl.$error }">
          {{ $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CALLBACK_URL.LABEL') }}
          <input
            v-model.trim="callbackUrl"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CALLBACK_URL.PLACEHOLDER')
            "
            @blur="$v.callbackUrl.$touch"
          />
          <span v-if="$v.callbackUrl.$error" class="message">{{
            $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CALLBACK_URL.ERROR')
          }}</span>
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.CALLBACK_URL.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

// Optional, and checked only when given: a reply normally goes to the address
// inside the signed handoff, and this is the fallback for a uniPLUS deployment
// that sends none. It still has to be https — it carries an agent's words to a
// customer.
const secureUrlIfPresent = (value = '') =>
  value ? value.startsWith('https://') : true;

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      tenantId: '',
      callbackUrl: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    tenantId: { required },
    callbackUrl: { secureUrlIfPresent },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const uniplusChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'uniplus',
              uniplus_tenant_id: this.tenantId,
              callback_url: this.callbackUrl,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: uniplusChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.UNIPLUS_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
